import React, {useState} from "react";
import IntroductionListType from "./subPages/IntroductionListType";
import {addYears} from "date-fns";
import {getIntroductionList} from "../../../api/lifecycle/introduction/IntroductionService";
import {toKSTISOString, toKSTISOStringEnd} from "../../../components/commonmethod/CommonMethod";
import useRequestData from "../../../hooks/useRequestData";
import {PageHeader} from "../../../components/PageHeader";

function IntroductionList() {

    const [checked, setChecked] = useState([]);

    const initDate = {
        startDate: toKSTISOString(addYears(new Date(), -1)),
        endDate: toKSTISOStringEnd(addYears(new Date(), 0)),
    }

    const {newData, pageInfo, dataHook} = useRequestData(getIntroductionList, initDate, "introduction");

    return (
        <>
            <div className="common-container">
                <PageHeader header={"자산도입관리"} indicator={"라이프사이클 > 자산도입관리 > 자산도입관리"}/>
                <IntroductionListType
                    data={newData} dataHook={dataHook}
                    date={initDate} pageInfo={pageInfo}
                    checked={{checked: checked, setChecked: setChecked}}/>
            </div>
        </>
    );
}

export {IntroductionList};